import { Form } from './form.js';
import { Event } from '../global/event.js';
import { Autocomplete } from '../global/autocomplete.js';

export class Input extends Event {
    constructor() {
        super();
        this.form = new Form();
        this.inputAusgabe = document.querySelector('#ausgaben');
        this.inputs = document.querySelectorAll('.formfields input');
        this.selects = document.querySelectorAll('.formfields select');
        this.inputHiddens = document.querySelectorAll('.hiddenfileupload');
        this.inputAddress = document.querySelectorAll('input[name*="street"], input[name*="housenumber"], input[name*="postcode"], input[name*="city"], select[name*="country"]');
        
        this.inputSalutation = document.querySelector('select[name="customer[salutation]"]');
        this.holderCompanyName = document.querySelector('label[for="userinfo-companyName"]');
        this.inputCompanyName = document.querySelector('[name="customer[companyName]"]');
        this.labelFirstName = document.querySelector("label[for='userinfo-firstName']");
        this.labelLastName = document.querySelector("label[for='userinfo-lastName']");

        this.autoCompleteCity = new Autocomplete(this.form.getRawElement('city'));
        this.autoCompleteCity.listener = this.form.getRawElement('postcode');

        this.init();
    };

    init() {
        if(this.holderCompanyName) {
            this.holderCompanyName = OVS.app.helper.getClosest(this.holderCompanyName, '.form-group');
        }
        
        // Anrede
        if (this.inputSalutation) {
            this.inputSalutation.addEventListener('change', event => {
                event.currentTarget.setAttribute('touched', true);
                let value = this.inputSalutation.value;
                if(value != "Divers" && value != 'Neutral') {
                    if (value == "unset") {
                        value = 'Bitte eingeben';
                    }
                } else {
                    value = '';
                }
                this.toggleCompanyName();
                this.fireEvent('updateInput', {name : this.inputSalutation.dataset.summary, value: value});
                this.checkFields();
            });
        }
        
        // Input Felder
        if(this.inputs) {
            this.inputs.forEach(input => {
                input.addEventListener('input', this.updateInput.bind(this));
                input.addEventListener('change', this.updateInput.bind(this));
                input.addEventListener('paste', this.updateInput.bind(this));
            })
        }
        
        if(this.inputHiddens) {
            this.inputHiddens.forEach(input => {
                input.addEventListener('input', this.updateInput.bind(this));
                input.addEventListener('change', this.updateInput.bind(this));
                input.addEventListener('paste', this.updateInput.bind(this));
            });
        }

        // PVA Ausgabe
        if(this.inputAusgabe) {
            this.inputAusgabe.addEventListener('change', () => {
                this.fireEvent('updateAusgabe', this.inputAusgabe.value);
            });
        }

        // Adresse geändert?
        if(this.inputAddress) {
            this.inputAddress.forEach(input => {
                input.addEventListener('blur', event => {
                    if(this.form.hasUpdated(event.currentTarget.getAttribute('name'))) {
                        event.currentTarget.dataset.old = event.currentTarget.value;
                        this.fireEvent('updateAddress');
                    }
                });
            });
        }
        
        this.toggleCompanyName();
    };
    
    updateInput(event) {
        event.currentTarget.setAttribute('touched', true);
        this.fireEvent('updateInput', {
            name : event.currentTarget.dataset.summary, 
            value : event.currentTarget.value
        });
        this.reset(event.currentTarget);
        this.checkFields();
    }

    checkFields() {
        let hasError = false;
        if(this.inputs) {
            this.inputs.forEach(input => {
                if(!this.isHidden(input)) {
                    if(input.required) {
                        if(input.value == '') {
                            hasError = true;
                            if(input.getAttribute('touched')) {
                                this.updateFieldStatus(input.getAttribute('name'), false, false);
                            }
                        }
                    }
                }
            });
        }
        
        if(this.selects) {
            this.selects.forEach(input => {
                if(!this.isHidden(input)) {
                    if(input.required) {
                        if(input.value == 'unset' || input.value == '') {
                            hasError = true;
                            if(input.getAttribute('touched')) {
                                this.updateFieldStatus(input.getAttribute('name'), false, false);
                            }
                        }
                    }
                }
            });
        }

        if(this.inputHiddens) {
            this.inputHiddens.forEach(input => {
                if(input.required) {
                    if(input.value == '') {
                        hasError = true;
                        if(input.getAttribute('touched')) {
                            this.updateFieldStatus(input.getAttribute('name'), false, false);
                        }
                    }
                }
            });
        }

        if(!hasError) {
            this.fireEvent('nextStep');
        }
    };

    reset(element) {
        this.updateFieldStatus(element.getAttribute('name'), true, false);
    };

    updateFieldStatus(key, valid, value) {
        let field = document.querySelector('[name="' + key + '"]');
        if(!field) {
            return false;
        }
        let holder = OVS.app.helper.getClosest(field, '.form-validate-parent');
        let label = false;
        let info = false;
        if(holder) {
            label = holder.querySelector('label');
            info = holder.querySelector('.form-error');
        }
        
        if(value) {
            field.value = value;
            this.fireEvent('updateInput', {name : field.dataset.summary, value: value});
        }
        
        if(label) {
            (!valid) ? label.classList.add('text-danger') : label.classList.remove('text-danger');
        }
        
        if(info) {
            (!valid) ? info.classList.remove('d-none') : info.classList.add('d-none');
        } 
        
        (!valid) ? field.classList.add('has-error') : field.classList.remove('has-error');
    };

    getParent(name) {
        let element = document.querySelector('input[name*="'+name+'"]');
        let parent = element.closest('.ce');
        if (parent.classList.contains('consignee')) return 'consignee';
        if (parent.classList.contains('broker')) return 'broker';
        return 'customer';
    }

    toggleCompanyName() {
        if(this.inputSalutation && this.inputSalutation.value == "Firma") {
            if(this.labelFirstName) {
                this.labelFirstName.innerHTML = 'Vorname (Ansprechpartner) *';
            }
            if(this.labelLastName) {
                this.labelLastName.innerHTML = 'Nachname (Ansprechpartner) *';
            }
            if(this.inputCompanyName) {
                this.inputCompanyName.required = true;
            }
            if(this.holderCompanyName) {
                this.holderCompanyName.classList.remove('d-none');
            }
        } else {
            if(this.labelFirstName) {
                this.labelFirstName.innerHTML = this.labelFirstName.dataset.text;
            }
            if(this.labelLastName) {
                this.labelLastName.innerHTML = this.labelLastName.dataset.text;
            }
            if(this.inputCompanyName) {
                this.inputCompanyName.required = false;
            }
            if(this.holderCompanyName) {
                this.holderCompanyName.classList.add('d-none');
            }
        }
    };
    
    isHidden(element) {
        return (element.offsetParent === null)
    }

}
